import React from 'react';

const Separator = ({ className = '' }) => <hr className={`separator ${className}`} />;

export default Separator;



// WEBPACK FOOTER //
// ./src/components/shared/Separator.js